<template>
  <div v-if="inputRecordFormVisible" style="width: 100%;">
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="所属门店：">
        <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small"
          @change="inputChange">
          <el-option v-for="item in storeList" :label="item.value" :value="item.keyId" :key="item.keyId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入库单号：">
        <el-input v-model="formInline.code" placeholder="请输入商品编码" clearable size="small"
          @change="inputChange"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" class="el-icon-search" @click="search()">
          搜索
        </el-button>
      </el-form-item>
    </el-form>
    <STable :columns="columnsData" :data="listData" :loading="loading" border stripe>
      <el-table-column slot="isConfirm" label="是否确认" min-width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isConfirm" type="success">已确认</el-tag>
          <el-tag v-else type="danger">未确认</el-tag>
        </template>
      </el-table-column>
    </STable>
    <!-- 分页组件 -->
    <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import {
  GetStoreProductHistoryPageList,
} from "@/api/productApi.js";
import {
  GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
export default {
  data() {
    return {
      inputRecordFormVisible: false,
      pageShow: true,
      loading: false, // 显示加载
      listData: [],
      // 分页参数
      pageparm: {
        pageIndex: 1,
        pageSize: 10,
        total: 0,
      },
      formInline: {
        pageIndex: 1,
        pageSize: 10,
        storeKeyId: "",
        typeName: "",
        productName: "",
        code: "",
        productTypeKeyId: "",
        type: 1,
        isConfirm: true,
      },
      columnsData: [], //显示列
      listColumns: [
        {
          prop: "rowNumber",
          label: "序号",
          align: "center",
          fixed: "left",
          width: "80",
          isKeep: true,
        },
        {
          prop: "storeName",
          label: "门店名称",
          isKeep: true,
          minWidth: "120",
          align: "center",
          fixed: "left",
        },
        {
          prop: "code",
          label: "入库单号",
          isKeep: true,
          minWidth: "200",
          align: "center",
          fixed: "left",
        },
        {
          prop: "productInfo.code",
          label: "商品编码",
          isKeep: true,
          minWidth: "170",
          align: "center",
          fixed: "left",
        },
        {
          prop: "productInfo.typeName",
          label: "类型名称",
          width: "120",
          align: "center",
        },
        {
          prop: "productInfo.productName",
          label: "商品名称",
          width: "180",
          align: "center",
        },
        {
          prop: "productInfo.specification",
          label: "规格",
          width: "150",
          align: "center",
        },
        {
          prop: "productInfo.unit",
          label: "单位",
          width: "120",
          align: "center",
        },
        {
          prop: "price",
          label: "价格（元）",
          width: "120",
          align: "center",
        },
        {
          prop: "quantity",
          label: "入库数量",
          width: "120",
          align: "center",
        },
        {
          prop: "typeName",
          label: "入库类型",
          width: "120",
          align: "center",
        },
        {
          prop: "content",
          label: "入库内容",
          width: "120",
          align: "center",
        },
        {
          prop: "remark",
          label: "入库备注",
          width: "120",
          align: "center",
        },
        {
          prop: "productDate",
          label: "生产日期",
          width: "120",
          align: "center",
        },
        {
          prop: "expireDate",
          label: "过期日期",
          width: "120",
          align: "center",
        },
        {
          slot: "isConfirm",
          label: "是否确认",
          width: "120",
          align: "center",
        },
        {
          prop: "confirmUserName",
          label: "确认人",
          width: "120",
          align: "center",
        },
        {
          prop: "confirmTime",
          label: "确认时间",
          width: "170",
          align: "center",
        },
        {
          prop: "creator",
          label: "创建人",
          width: "120",
          align: "center",
        },
        {
          prop: "createTime",
          label: "创建时间",
          width: "170",
          align: "center",
        },
        {
          prop: "editor",
          label: "维护人",
          width: "120",
          align: "center",
        },
        {
          prop: "updateTime",
          label: "维护时间",
          width: "170",
          align: "center",
        },
        {
          slot: "operation",
          label: "操作",
          width: "120",
          align: "center",
        },
      ],
      storeList: [],
    };
  },
  // 注册组件
  components: {},
  created() {
    // 初始列
    this.getCheckBox(this.listColumns.map((item) => item.label));
    this.GetOrgInfoListByConfig();
  },
  computed: {},
  methods: {
    // 获取筛选框
    getCheckBox(val) {
      let arr = this.listColumns.filter((v) => !val.includes(v.label));
      this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
    },
    // 显示弹窗
    showInputRecordDialog(keyId, productTypeKeyId) {
      this.inputRecordFormVisible = true;
      this.formInline.productTypeKeyId = productTypeKeyId;
      this.search();
    },
    // 关闭弹窗
    closeInputRecordDialog() {
      this.inputRecordFormVisible = false;
    },
    // 获取所属门店
    GetOrgInfoListByConfig() {
      const paramer = {
        key: 1,
      };
      GetOrgInfoListByConfig(paramer)
        .then((res) => {
          if (res.code == 1) {
            this.storeList = [];
            if (res.code == 1) {
              res.data.forEach((item) => {
                this.storeList.push({
                  keyId: item.keyId,
                  value: item.name + '【' + item.remark2 + '】',
                });
              });
            } else {
              this.$message.error(res.msg);
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("获取门店信息失败!");
        });
    },
    changePages() { },
    // 获取列表
    getListData() {
      this.loading = true;
      GetStoreProductHistoryPageList(this.formInline)
        .then((res) => {
          if (res.code == 1) {
            this.loading = false;
            this.listData = res.data;
            this.pageparm.total = res.totalNumber;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    // 重置
    clearAll() {
      this.$data.formInline = this.$options.data.call(this).formInline;
      this.search();
    },
    inputChange(val) {
      this.search();
    },
    // 分页插件事件
    callFather(parm) {
      if (parm.currentPage == undefined) {
        this.formInline.pageIndex = 1;
      } else {
        this.formInline.pageIndex = parm.currentPage;
      }
      this.formInline.pageSize = parm.pageSize;
      this.getListData();
    },
    // 搜索事件
    search() {
      this.formInline.pageIndex = 1;
      this.pageShow = false;
      this.$nextTick(() => {
        this.pageShow = true;
      });
      this.getListData();
    },
  },
};
</script>

<style scoped>
.one_1 {
  padding: 2px 20px;
  background: #e6f7ff;
  border: 1px solid #6acaf3;
  color: #56bbfd;
  border-radius: 2px;
}

.one_2 {
  padding: 2px 20px;
  background: #fcd4ff;
  border: 1px solid #dfbce2;
  color: #ea7cff;
  border-radius: 2px;
}
</style>